import { makeStyles, tokens } from '@fluentui/react-components';

export const baggageInfoDialogWidthBreakpoint = 470;

export const useMisconnectedCustomerInfoDialogStyles = makeStyles({
    dialogTitleIcon: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '40px',
        height: '40px',
        borderRadius: '3px',
        backgroundColor: tokens.colorBrandBackgroundStatic,
    },
    groupBookingLabel: {
        fontSize: tokens.fontSizeBase300,
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        margin: '10px 0 20px 0',
    },
});

export const useContentSkeletonStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        height: '100%',
    },
    item: {
        minHeight: '150px',
    },
});

export const useReflightInfoStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
    },
    dataRow: {
        alignItems: 'end',
    },
    dataRowLabel: {
        maxWidth: '130px',
    },
    dataRowLabelBold: {
        fontWeight: 'bold',
    },
    warningValue: {
        color: '#835B00',
    },
});

export const useDataRowStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '10px',
    },
    dataRowValue: {
        fontWeight: 'bold',
    },
    vertical: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '10px',
    },
});
